<template>
    <div v-if="isLoadingAction" class="wrapper">
        <loader :margin="1" />
    </div>
    <div v-else-if="status === 1" class="wrapper">
        <a v-if="isExtendAllowed" href="#" @click.prevent="$emit('extend')">
            <i class="cus-add" />
            <span>Extend Stay</span>
        </a>
        <a v-if="isUndoCheckInAllowed" href="#" @click.prevent="$emit('undo')">
            <i class="cus-arrow-undo" />
            <span>Undo Check In</span>
        </a>
        <a
            v-if="_hasAccess('schedule.boarding.checkout')"
            href="#"
            @click.prevent="$emit('checkout')"
        >
            <i class="cus-door-out" />
            <span>Check Out</span>
        </a>
        <a
            v-if="_hasAccess('schedule.boarding.create')"
            href="#"
            @click.prevent="$emit('split')"
        >
            <i class="cus-arrow-divide" />
            <span>Split</span>
        </a>
        <a href="#" @click.prevent="$emit('cagecard')">
            <i class="cus-printer" />
            <span>Cage Card</span>
        </a>
    </div>
    <div v-else-if="status === 2" class="wrapper">
        <a href="#" @click.prevent="$emit('cagecard')">
            <i class="cus-page-white-edit" />
            <span>Cage Card</span>
        </a>
    </div>
    <div v-else class="wrapper">
        <a
            v-if="_hasAccess('schedule.boarding.update')"
            href="#"
            @click.prevent="$emit('edit')"
        >
            <i class="cus-page-white-edit" />
            <span>Edit</span>
        </a>
        <a
            v-if="_hasAccess('schedule.boarding.checkin')"
            href="#"
            @click.prevent="$emit('checkin')"
        >
            <i class="cus-door-in" />
            <span>Check In</span>
        </a>
        <a
            v-if="_hasAccess('schedule.boarding.delete')"
            href="#"
            @click.prevent="$emit('cancel')"
        >
            <i class="cus-delete" />
            <span>Cancel</span>
        </a>
    </div>
</template>

<script>
import Loader from "@/module/commons/loader";

export default {
    props: {
        status: {
            type: Number,
            default: 0 // (0)reserved | (1)checked-in | (2)checked-out
        },
        boarding: {
            type: Object,
            default: null
        }
    },
    components: {
        Loader
    },
    computed: {
        isExtendAllowed() {
            if (!this._hasAccess("schedule.boarding.update")) {
                return false;
            }
            if (this.boarding && this.boarding.invoice === null) {
                return false;
            }
            return true;
        },
        isUndoCheckInAllowed() {
            if (!this._hasAccess("schedule.boarding.undo.checkin")) {
                return false;
            }

            if (this.boarding && this.boarding.invoice) {
                let { balance, amount, status } = this.boarding.invoice;
                if (balance === amount && status === 1) {
                    // 1 = invoice open (if invoice has been paid, cannot undo checkin)
                    return true;
                }
            }

            // able to undo even invoice has been deleted
            if (this.boarding?.invoice === null) {
                return true;
            }

            return false;
        },
        isLoadingAction() {
            // we use vuex because this component is shared with boarding dashboard and calendar
            return this.$store.state.modalReservation.isLoadingFooterPreview;
        }
    }
};
</script>

<style scoped>
.wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    row-gap: 10px;
}
a {
    display: flex;
    align-items: center;
    padding-right: 12px;
}
span {
    display: inline-block;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
